import { z } from "zod/v4";

// Game chat messages (legacy)
export const chatMessageSchema = z.object({
	content: z.string(),
	created_at: z.coerce.date(),
	game_id: z.string().uuid(),
	id: z.string().uuid(),
	sender_id: z.string().uuid(),
});

export const createChatMessageSchema = chatMessageSchema.omit({
	created_at: true,
	id: true,
});

export const messageReactionSchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	emoji: z.string(),
	user_id: z.string().uuid(),
});

export const messageQuoteSchema = z.object({
	content: z.string(),
	id: z.string().uuid(),
	image_url: z.string().nullable().optional(),
	sender_display_name: z.string(),
});

// Room chat messages (club chat). Reply, reactions and edit time are on the
// wire; older clients ignored them.
export const roomChatMessageSchema = z.object({
	chat_room_id: z.string().uuid(),
	content: z.string(),
	created_at: z.coerce.date(),
	edited_at: z.coerce.date().nullable().optional(),
	id: z.string().uuid(),
	image_url: z.string().nullable().optional(),
	reactions: z.array(messageReactionSchema).optional(),
	reply_to: messageQuoteSchema.nullable().optional(),
	sender_avatar_url: z.string().nullable().optional(),
	sender_display_name: z.string(),
	sender_id: z.string().uuid(),
});

export const sendRoomMessageSchema = z.object({
	content: z.string().min(1).max(2000),
});

// Admin chat message response (full message with all fields)
export const adminChatMessageSchema = z.object({
	chat_room_id: z.string().uuid().nullable(),
	content: z.string(),
	created_at: z.coerce.date(),
	edited_at: z.coerce.date().nullable().optional(),
	game_id: z.string().uuid().nullable(),
	id: z.string().uuid(),
	image_url: z.string().nullable().optional(),
	reply_to: z
		.object({
			content: z.string(),
			id: z.string().uuid(),
			image_url: z.string().nullable().optional(),
			sender_display_name: z.string(),
		})
		.nullable()
		.optional(),
	sender_avatar_url: z.string().nullable().optional(),
	sender_display_name: z.string(),
	sender_id: z.string().uuid(),
});

export type AdminChatMessage = z.infer<typeof adminChatMessageSchema>;
